import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const midday = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '$brandBlack',
    pageBackground: '#F5F3EB',
    secondaryFont: '#F97312',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.paris.midday.accent
      ? THEME_DEFAULT_FONTS.paris.midday.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.paris.midday.body.value,
    heading: THEME_DEFAULT_FONTS.paris.midday.headline.value,
  },
  fontWeights: {
    body: 400,
    heading: 400,
  },
});
